export const SHOW_WELCOME = 'SHOW_WELCOME';
export const HIDE_WELCOME = 'HIDE_WELCOME';



